import { FC } from 'react'
import clsx from 'clsx'

import styles from './Loading.module.scss'

interface ILoading {
  wrapperModificator?: string
  modificator?: string
  height?: string | number
  width?: string | number
  color?: string
  radius?: number
}
const Loading: FC<ILoading> = ({
  wrapperModificator,
  modificator,
  width = '6.25rem',
  height = '6.25rem',
  color = '#22ccc7',
}) => {
  return (
    <div className={clsx(styles.load, wrapperModificator)}>
      <svg
        className={modificator}
        viewBox="0 0 38 38"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width, height }}
      >
        <g transform="translate(1 1)">
          <path
            d="M36 18c0-9.94-8.06-18-18-18"
            id="Oval-2"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            fill="none"
            fillRule="evenodd"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="0.9s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </svg>
    </div>
  )
}

export default Loading
